import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const ControlSystems = ({ controls, onControlChange }) => {
  const effectivenessOptions = [
    { value: 'excellent', label: 'Sangat Efektif (90-100%)' },
    { value: 'good', label: 'Efektif (70-89%)' },
    { value: 'fair', label: 'Cukup Efektif (50-69%)' },
    { value: 'poor', label: 'Kurang Efektif (30-49%)' },
    { value: 'none', label: 'Tidak Ada/Tidak Efektif (<30%)' }
  ];

  const frequencyOptions = [
    { value: 'daily', label: 'Harian' },
    { value: 'weekly', label: 'Mingguan' },
    { value: 'monthly', label: 'Bulanan' },
    { value: 'quarterly', label: 'Triwulanan' },
    { value: 'annual', label: 'Tahunan' },
    { value: 'adhoc', label: 'Ad-hoc/Tidak Terjadwal' }
  ];

  const controlAreas = [
    {
      id: 'financial',
      title: 'Kontrol Keuangan',
      icon: 'DollarSign',
      items: [
        { key: 'budgetControl', label: 'Kontrol Anggaran dan Pengeluaran' },
        { key: 'cashflowMonitoring', label: 'Monitoring Arus Kas' },
        { key: 'financialReporting', label: 'Pelaporan Keuangan Berkala' },
        { key: 'auditProcess', label: 'Proses Audit Internal/Eksternal' }
      ]
    },
    {
      id: 'operational',
      title: 'Kontrol Operasional',
      icon: 'Settings',
      items: [
        { key: 'productionMonitoring', label: 'Monitoring Produksi Harian' },
        { key: 'inventoryControl', label: 'Kontrol Inventori dan Stok' },
        { key: 'supplierEvaluation', label: 'Evaluasi Kinerja Pemasok' },
        { key: 'maintenanceSchedule', label: 'Jadwal Pemeliharaan Peralatan' }
      ]
    },
    {
      id: 'quality',
      title: 'Kontrol Kualitas',
      icon: 'Shield',
      items: [
        { key: 'qualityTesting', label: 'Pengujian Kualitas Produk' },
        { key: 'standardCompliance', label: 'Kepatuhan Standar Industri' },
        { key: 'traceability', label: 'Sistem Traceability' },
        { key: 'customerComplaint', label: 'Penanganan Keluhan Pelanggan' }
      ]
    },
    {
      id: 'compliance',
      title: 'Kepatuhan Regulasi',
      icon: 'FileCheck',
      items: [
        { key: 'licensing', label: 'Perizinan dan Sertifikasi' },
        { key: 'foodSafety', label: 'Keamanan Pangan (HACCP/ISO)' },
        { key: 'laborCompliance', label: 'Kepatuhan Ketenagakerjaan' },
        { key: 'environmental', label: 'Kepatuhan Lingkungan' }
      ]
    }
  ];

  return (
    <div className="card">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-semibold mb-2">Sistem Kontrol dan Tata Kelola</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Evaluasi efektivitas sistem kontrol internal dan mekanisme pengawasan operasional
          </p>
        </div>
        <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="ShieldCheck" size={24} color="var(--color-primary)" />
        </div>
      </div>
      <div className="space-y-8">
        {controlAreas?.map((area) => (
          <div key={area?.id} className="p-4 md:p-6 bg-muted/30 rounded-lg border border-border">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name={area?.icon} size={20} color="var(--color-primary)" />
              </div>
              <h3 className="text-lg md:text-xl font-semibold">{area?.title}</h3>
            </div>

            <div className="space-y-6">
              {area?.items?.map((item) => (
                <div key={item?.key} className="space-y-4">
                  <Checkbox
                    label={item?.label}
                    checked={controls?.[area?.id]?.[item?.key]?.implemented || false}
                    onChange={(e) => 
                      onControlChange(area?.id, item?.key, 'implemented', e?.target?.checked)
                    }
                  />

                  {controls?.[area?.id]?.[item?.key]?.implemented && (
                    <div className="ml-8 grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Select
                        label="Tingkat Efektivitas"
                        placeholder="Pilih tingkat efektivitas"
                        options={effectivenessOptions}
                        value={controls?.[area?.id]?.[item?.key]?.effectiveness || ''}
                        onChange={(value) => 
                          onControlChange(area?.id, item?.key, 'effectiveness', value)
                        }
                        required
                      />

                      <Select
                        label="Frekuensi Review"
                        placeholder="Pilih frekuensi"
                        options={frequencyOptions}
                        value={controls?.[area?.id]?.[item?.key]?.frequency || ''}
                        onChange={(value) => 
                          onControlChange(area?.id, item?.key, 'frequency', value)
                        }
                        required
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-warning/10 rounded-lg border border-warning/20">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-medium text-warning-foreground mb-1">Penting untuk Scale-Up</p>
            <p className="text-muted-foreground">
              Sistem kontrol yang lemah adalah risiko kritis saat scale-up. Pastikan semua area kontrol utama memiliki efektivitas minimal "Cukup Efektif" sebelum ekspansi.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlSystems;